import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Exclude, Expose } from 'class-transformer';
import { IsBoolean, IsEnum, IsNumber, IsUUID } from 'class-validator';
import { CommonEntityDto } from '../../common/dto/common-entity.dto';
import { ContractorAllocationInterface } from '../interfaces/contractor-allocation.interface';
import { ContractorResourceTypeEnum } from '../../contractor/enums/contractor-resource-type.enum';
import { ContractorDto } from '../../contractor/dto/contractor.dto';
import { JobPhaseDto } from '../../job-phase/dto/job-phase.dto';

@Exclude()
export class ContractorAllocationDto
  extends CommonEntityDto
  implements ContractorAllocationInterface
{
  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Associated Contractor ID',
    description: 'The contractor that owns this allocation',
  })
  @IsUUID()
  @Expose()
  contractorId!: string;

  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Associated Job Phase ID',
    description: 'The job phase consuming this allocation',
  })
  @IsUUID()
  @Expose()
  jobPhaseId!: string;

  @ApiProperty({
    title: 'Resource Type',
    description: 'The resource type being allocated',
    enum: ContractorResourceTypeEnum,
  })
  @IsEnum(ContractorResourceTypeEnum)
  @Expose()
  resourceType!: ContractorResourceTypeEnum;

  @ApiProperty({
    title: 'Allocated Amount',
    description:
      'The amount allocated (payableTotal for board-based phases, totalSquareFootage for sprayer)',
  })
  @IsNumber()
  @Expose()
  allocatedAmount!: number;

  @ApiProperty({
    type: 'boolean',
    default: false,
    title: 'Released',
    description:
      'Whether this allocation has been released after job phase approval',
  })
  @IsBoolean()
  @Expose()
  released!: boolean;

  @ApiProperty({
    type: 'string',
    format: 'date-time',
    nullable: true,
    title: 'Released At',
    description:
      'The date and time when the allocation was released upon job phase approval',
  })
  @Expose()
  releasedAt!: Date | null;

  @ApiPropertyOptional({
    type: () => ContractorDto,
    title: 'Associated Contractor',
    description: 'The contractor associated with this allocation',
  })
  @Expose()
  contractor?: ContractorDto;

  @ApiPropertyOptional({
    type: () => JobPhaseDto,
    title: 'Associated Job Phase',
    description: 'The job phase associated with this allocation',
  })
  @Expose()
  jobPhase?: JobPhaseDto;
}
